import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/mercari-limited-or-closed-account';

export default function Example() {
  return (
    <>
      <Head>
        <title>Mercari Limited or Closed Your Account? Get To Know The Reasons Why and How You Can Get It Back</title>
        <meta
          name='description'
          content='Familiarize yourself with how you can avoid your Mercari account from getting limited or closed. Learn the factors that cause this and how you can retrieve your account if it happens.'
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/mercari-limited-or-closed-account' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/mercari-limited-or-closed-account' />
        <meta
          property='og:title'
          content='Mercari Limited or Closed Your Account? Get To Know The Reasons Why and How You Can Get It Back'
        />
        <meta
          property='og:description'
          content='Familiarize yourself with how you can avoid your Mercari account from getting limited or closed. Learn the factors that cause this and how you can retrieve your account if it happens.'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=4' />
        <meta property='article:published_time' content='April 14th, 2022' />
        <meta property='article:modified_time' content='April 14th, 2022' />
        <meta property='article:tag' content='Mercari' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
